import React, { useEffect, useState } from "react";
import { Button, ButtonGroup, Flex, Image } from "@chakra-ui/react";

import { motion } from "framer-motion";



export default function FixedTab({ headers }) {
  const [activeSection, setActiveSection] = useState(null);
  const [activeSubSection, setActiveSubSection] = useState(null);
  // const [allHeaders.current, setallHeaders.current] = useState(headers)

  const allHeaders = React.useRef(headers);

  useEffect(() => {
    allHeaders.current = headers;
  }, [headers]);

  const onScroll = () => {
    const scrollPosition = window.scrollY;

    for (let i = 0; i < allHeaders.current.length; i++) {
      const section = document.getElementById(allHeaders.current[i].id);
      if (!section) continue; // Skip if section is null
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;
      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        setActiveSection(allHeaders.current[i]);
        if (!allHeaders.current[i].subSections || allHeaders.current[i].subSections.length === 0) {
          setActiveSubSection(null);
        }
        break;
      }
      for (let j = 0; j < allHeaders.current[i].subSections.length; j++) {
        const subSection = document.getElementById(
          allHeaders.current[i].subSections[j].id
        );
        if (!subSection) continue; // Skip if sub-section is null
        const subSectionTop = subSection.offsetTop - 70;
        const subSectionBottom = subSectionTop + subSection.offsetHeight;
        if (
          scrollPosition >= subSectionTop &&
          scrollPosition < subSectionBottom
        ) {
          setActiveSection(allHeaders.current[i]);
          setActiveSubSection(allHeaders.current[i].subSections[j]);
          break;
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSectionClick = (section: any) => {
    setActiveSection(section);
    setActiveSubSection(null);
    window.location.hash = section.id;
  };

  const handleSubSectionClick = (subSection) => {
    setActiveSubSection(subSection);

    window.location.hash = subSection.id;
  };
  return (
    <Flex minWidth={"100%"} direction="column">
      <Image
        alignSelf={"center"}
        src={
          "https://static.anderspink.com/pages/new-homepage/ap-logo-white.png"
        }
        alt="logo"
        m={5}
        w={100}
        h={100}
      />
      <Flex flexDirection={"column"} minWidth={"100%"}>
        {allHeaders.current.map((section: any) => (
          <React.Fragment key={section.id}>
            <Button
              key={section.id}
              textDecoration={"none"}
              color={
                activeSection === section && !activeSubSection
                  ? "#6c8eef"
                  : "gray.100"
              }
              bg={
                activeSection === section && !activeSubSection
                  ? "#2a2f45"
                  : "inherit"
              }
              fontWeight={activeSection === section ? "extrabold" : "bold"}
              variant="unstyled"
              onClick={() => handleSectionClick(section)}
              fontSize={"12px"}
              textAlign="start"
              w={"100%"}
              height={"30px"}
              pl={4}
            >
              {section.title}
            </Button>

            {activeSection === section && section.subSections.length > 0 && (
              <motion.div
                key={`${section.id}-subsections`}
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{ duration: 0.4 }}
              >
                <ButtonGroup flexDirection={"column"} minWidth={"100%"}>
                  {section.subSections.map((section: any) => (
                    <Button
                      key={section.id}
                      color={
                        activeSubSection === section ? "#6c8eef" : "gray.100"
                      }
                      bg={activeSubSection === section ? "#2a2f45" : "inherit"}
                      variant="unstyled"
                      fontWeight={"bold"}
                      onClick={() => handleSubSectionClick(section)}
                      fontSize={"12px"}
                      textAlign="start"
                      height={"30px"}
                      w={"100%"}
                      pl={8}
                      marginInlineStart={"0rem !important"}
                    >
                      {section.title}
                    </Button>
                  ))}
                </ButtonGroup>
              </motion.div>
            )}
          </React.Fragment>
        ))}
      </Flex>
    </Flex>
  );
}
